<template>
  <div class="lbv-search animated fadeIn roundedCard">
    <b-card>
      <h1 class="lbv-page-title">
        Assign Tenant to Device
      </h1>
      <form
        class="lbv-search-filter"
        @submit.prevent="assignTenant"
      >
        <div class="leaklistFilters w-100">
          <b-row class="d-flex align-items-center">
            <b-col>
              <b-form-group
                label="Device ID"
                label-for="device-id"
              >
                <input
                  id="device-id"
                  v-model="searchDeviceID"
                  type="text"
                  class="form-control full-width"
                  placeholder="LeakBot ID"
                >
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group
                label="Tenant"
                label-for="select-tenant"
              >
                <b-form-select
                  id="select-tenant"
                  v-model="tenantSelection"
                  class="full-width"
                >
                  <option :value="null">
                    None
                  </option>
                  <option
                    v-for="tenant in tenants"
                    v-bind="$attrs"
                    :value="{ id: tenant.id }"
                    @option="$emit('option', $event.target.value)"
                  >
                    {{ tenant.name }}
                  </option>
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col cols="3">
              <b-button
                id="applyBtn"
                variant="primary"
                type="submit"
                class="applyFilter rounded-pill"
              >
                Assign
              </b-button>
            </b-col>
          </b-row>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>
import assignMixin from '../mixins/assignTenantMixin'

export default {
  name: 'AssignTenant',
  mixins: [assignMixin]
}
</script>
<style scoped media="screen">
.lbv-search .full-width {
  width: 100% !important;
}
</style>
